/* eslint-disable react/no-multi-comp */
import React from 'react';
import PropTypes from 'prop-types';
import InputField from './InputField';

import Alert from '@mui/lab/Alert';

import auth from '../../services/appAuth';
import { ENV, ENVIRONMENTS } from '../../constants/EndPoints';
import { Exception } from 'sass';

const PASSWORD_MIN_LENGTH = 12;

function validPasswordLength(password) {
  const pattern = /^(?=.{12})/;
  return pattern.test(password);
}
function validPasswordLowercase(password) {
  const pattern = /^(?=.*[a-z])/;
  return pattern.test(password);
}
function validPasswordUppercase(password) {
  const pattern = /^(?=.*[A-Z])/;
  return pattern.test(password);
}
function validPasswordContainNumber(password) {
  const pattern = /^(?=.*[0-9])/;
  return pattern.test(password);
}

export default function ResetPassword(props, context) {
  const [error, setError] = React.useState(null);
  const [success, setSuccess] = React.useState(null);
  const [stage, setStage] = React.useState('send-mail');
  const [authResponse, setAuthResponse] = React.useState({});
  const [email, setEmail] = React.useState('');
  const [code, setCode] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [passwordAgain, setPasswordAgain] = React.useState('');
  const [passwordError, setPasswordError] = React.useState(null);
  const [passwordAgainError, setPasswordAgainError] = React.useState(null);

  function handleInputChange(setter) {
    return (event) => {
      setter(event.target.value);
    };
  }

  React.useEffect(() => {
    let errorMessage = null;
    if (!validPasswordLength(password)) {
      errorMessage = context.t('at_least_length_characters_are_required', {
        length: PASSWORD_MIN_LENGTH,
      });
    } else if (!validPasswordLowercase(password)) {
      errorMessage = context.t('at_least_one_lowercase_letter');
    } else if (!validPasswordUppercase(password)) {
      errorMessage = context.t('at_least_one_uppercase_letter');
    } else if (!validPasswordContainNumber(password)) {
      errorMessage = context.t('at_least_one_number');
    }
    setPasswordError(errorMessage);

    if (passwordAgain.length > 0) {
      checkSamePasswordValue();
    }
  }, [password]);

  React.useEffect(() => {
    checkSamePasswordValue();
  }, [passwordAgain]);

  function checkSamePasswordValue() {
    const error =
      password !== passwordAgain
        ? context.t('the_passwords_are_not_the_same')
        : null;
    setPasswordAgainError(error);
  }

  function handleButtonClick() {
    setError(null);
    setSuccess(null);

    if (stage === 'send-mail') {
      props.setLoading(true);
      auth
        .sendPasswordResetEmail(email)
        .then(() => {
          setAuthResponse({ Destination: email });
          // setSuccess({
          //   message:
          //     'Email was sent, please check your inbox. Might take a few minutes.',
          // });
          if (process.env.REACT_APP_AUTH_PROVIDER === 'cognito') {
            setStage('change-password');
          } else {
            setStage('mail-sent');
          }
        })
        .catch((err) => {
          // console.log('DEBUG   ', err, ' DEBUG ', err.code);
          if (err.code === 'auth/user-not-found')
            err.message = 'No account was found with that email address.';
          setError(err);
        })
        .finally(() => props.setLoading(false));
    }

    if (stage === 'change-password') {
      if (
        !validPasswordLength(password) ||
        !validPasswordLowercase(password) ||
        !validPasswordUppercase(password) ||
        !validPasswordUppercase(password)
      ) {
        setError({ message: context.t('invalid_password') });
      } else if (password !== passwordAgain) {
        setError({ message: context.t('the_passwords_are_not_the_same') });
      } else {
        props.setLoading(true);
        auth
          .setNewPassword(email, code, password)
          .then((data) => {
            // console.log(data);
            props.signInFunc(email, password, (err) => {
              if (err) {
                setError(err);
                props.setLoading(false);
              }
            });
          })
          .catch((err) => {
            props.setLoading(false);
            setError(err);
          });
      }
    }
  }

  return (
    <div>
      {error && (
        <Alert
          style={{ position: 'absolute', top: '-35%', fontSize: 'large' }}
          severity='error'
        >
          {error.message}
        </Alert>
      )}
      {success && (
        <Alert
          style={{ position: 'absolute', top: '-35%', fontSize: 'large' }}
          severity='success'
        >
          {success.message}
        </Alert>
      )}
      <div style={{ paddingTop: 10 }}>
        <a href='#' onClick={() => props.backTo('signIn')}>
          {context.t('back_to_signin_page')}
        </a>
      </div>
      {stage === 'send-mail' && (
        <SendEmail
          email={email}
          handleInputChange={handleInputChange(setEmail)}
          loading={props.loading}
          handleButtonClick={handleButtonClick}
        />
      )}
      {stage === 'mail-sent' && (
        <SendEmailSuccess email={email} t={context.t} />
      )}
      {stage === 'change-password' && authResponse.Destination && (
        <ChangePassword
          authResponse={authResponse}
          code={code}
          password={password}
          passwordError={passwordError}
          passwordAgain={passwordAgain}
          passwordAgainError={passwordAgainError}
          handleCodeChange={handleInputChange(setCode)}
          handlePasswordChange={handleInputChange(setPassword)}
          handlePasswordAgainChange={handleInputChange(setPasswordAgain)}
          handleButtonClick={handleButtonClick}
          loading={props.loading}
        />
      )}
    </div>
  );
}

ResetPassword.contextTypes = {
  t: PropTypes.func.isRequired,
};

ResetPassword.propTypes = {
  backTo: PropTypes.func,
  loading: PropTypes.bool,
  setLoading: PropTypes.func.isRequired,
  signInFunc: PropTypes.func.isRequired,
};

function SendEmail(props, context) {
  return (
    <div>
      <h2>{context.t('forgot_your_password')}</h2>
      <p>{context.t('email_to_reset_password')}</p>
      <InputField
        label={context.t('email')}
        name='email'
        type='email'
        value={props.email}
        onChange={props.handleInputChange}
        disabled={props.loading}
      />

      <div className='form-group form-actions'>
        <div className='col-xs-6 col-xs-offset-3 login-field'>
          <button
            className='login-submit btn btn-success btn-block'
            style={{ display: 'block', margin: '0 auto', width: 'auto' }}
            type='submit'
            onClick={props.handleButtonClick}
          >
            {context.t('reset_my_password')}
          </button>
        </div>
      </div>
    </div>
  );
}
SendEmail.contextTypes = {
  t: PropTypes.func.isRequired,
};
SendEmail.propTypes = {
  email: PropTypes.string.isRequired,
  handleButtonClick: PropTypes.func.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

function SendEmailSuccess(props, context) {
  return (
    <div style={{ paddingTop: 40 }}>
      <p style={{ fontSize: 25 }}>
        Reset Email was sent to:
        <br />
        <strong style={{ fontSize: 15, paddingLeft: 5 }}>
          -  {props.email}
        </strong>
        .
      </p>

      <p style={{ paddingTop: 25 }}>
        Please check your inbox. It might take a few minutes to arrive.
      </p>
    </div>
  );
}

SendEmailSuccess.propTypes = {
  email: PropTypes.string.isRequired,
};
SendEmailSuccess.contextTypes = {
  t: PropTypes.func.isRequired,
};

function ChangePassword(props, context) {
  return (
    <div>
      <p>
        {context.t('email_to_reset_password_sent', {
          mail: props.authResponse.Destination,
        })}
      </p>
      <InputField
        label={context.t('code')}
        name='code'
        type='text'
        value={props.code}
        onChange={props.handleCodeChange}
        disabled={props.loading}
      />
      <InputField
        label={context.t('new_password')}
        name='newPassword'
        type='password'
        value={props.password}
        onChange={props.handlePasswordChange}
        disabled={props.loading}
        error={props.passwordError}
      />
      <InputField
        label={context.t('confirm_new_password')}
        name='newPasswordAgain'
        type='password'
        value={props.passwordAgain}
        onChange={props.handlePasswordAgainChange}
        disabled={props.loading}
        error={props.passwordAgainError}
      />

      <div className='form-group form-actions'>
        <div className='col-xs-6 col-xs-offset-3 login-field'>
          <button
            className='login-submit btn btn-success btn-block'
            type='submit'
            onClick={props.handleButtonClick}
          >
            {context.t('change_password')}
          </button>
        </div>
      </div>
    </div>
  );
}
ChangePassword.contextTypes = {
  t: PropTypes.func.isRequired,
};
ChangePassword.propTypes = {
  authResponse: PropTypes.object.isRequired,
  code: PropTypes.string.isRequired,
  handleButtonClick: PropTypes.func.isRequired,
  handleCodeChange: PropTypes.func.isRequired,
  handlePasswordAgainChange: PropTypes.func.isRequired,
  handlePasswordChange: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  password: PropTypes.string.isRequired,
  passwordAgain: PropTypes.string.isRequired,
  passwordAgainError: PropTypes.string.isRequired,
  passwordError: PropTypes.string.isRequired,
};
